export default __webpack_public_path__ + "static/LeituraSansTwo-Light-caf09dc8edebfb353d08f40acc1df634.woff2";